export { FileText as default } from './FileText';
